import { render } from "./SubmitFormDetail.vue?vue&type=template&id=4254103f"
import script from "./SubmitFormDetail.vue?vue&type=script&lang=js"
export * from "./SubmitFormDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__